import {
  MessageBox,
  Message,
  Loading
} from 'element-ui'
import axios from 'axios'

// create an axios instance
const service = axios.create({
  baseURL: '/', // url = base url + request url
  // baseURL: process.env.NODE_ENV === 'production' ? 'http://192.168.1.107' : '/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
  // withCredentials: true, //跨域时若要发生cookie,需要设置该选项
})

let elLoading, elMessage;
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (process.env.NODE_ENV === 'development') {
      config.headers['sysid'] = 20;
      config.headers['token'] = 'TSKhxMX0aCZlV847gBDN7HSfuoRZUBGzcQDF1wwIRS8rBzPrxTPTtK5x-5u9WGjh';
      // if(config.url.includes('openapi')){
      //   config.data['access_token'] = 'YPTLcymc_fsTzPzVaRSCjynzHOu5q6e7x-G3Cw4ElmKKRMs3nHy-Tbpd-8sBeT47';
      // }
    }
    if (config.loading && !elLoading) {
      elLoading = Loading.service({
        text: "加载中",
        background: 'rgba(0, 0, 0, 0.3)',
        spinner: 'el-icon-loading',
      })
    }
    config.method = config.responseType == 'blob'?'get':'post';
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.config.responseType == 'blob') {
      return response
    }
    if (response.config.loading && elLoading) {
      elLoading.close()
    }
    if (response.status === 200) {
      if (response.data && response.data.error_code == 1011 && !elMessage) {
        elMessage = Message({
          message: response.data.error_msg,
          type: 'error',
          duration: 5 * 1000,
          onClose() {
            elMessage = null;
          }
        })

        setTimeout(() => {
          window.location.href = window.location.origin + response.data.result.url
        }, 3000)
      }
      if(response.data.error_code==1020||response.data.error_code==1014){
        MessageBox.confirm(response.data.error_msg||'您还未登录，立即去登录吧?', '提示', {
          confirmButtonText: response.data.error_code==1020?'去登录':'确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          history.back();
          window.open(response.data.error_code==1020?`manager/index/index`:'/manager/index/comboList', '_blank')
        }).catch(err=>{
          history.back();
        })
      }
      if (response.data && response.data.error_code && !elMessage) {
        elMessage = Message({
          message: response.data.error_msg || '操作失败',
          type: 'error',
          duration: 5 * 1000,
          onClose() {
            elMessage = null;
          }
        })
      }
      return Promise.resolve(response.data); //进行中
    } else {
      return Promise.reject(response); //失败
    }
  },
  error => {
    console.log('err' + error) // for debug
    if (elLoading) {
      elLoading.close()
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
